import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import CSSModules from 'react-css-modules';
import {autobind} from 'core-decorators';
import classNames from 'classnames';
import Tabs from 'components/common/material/Tabs';
import Tab from 'components/common/material/Tab';
import PayNowForm from 'pay-now/PayNowForm';
import UpdateDebitCard from './update-debit-card/UpdateDebitCard';
import {isPurchaseActive} from './helpers';
import {purchaseFetchAction, purchaseCardTabChangeAction} from './redux';
import PurchaseDetails from './PurchaseDetails';
import PurchaseSchedule from './PurchaseSchedule';
import PurchaseInbox from './PurchaseInbox';
import styles from './purchaseCard.scss';
import { trackEvent } from "../reducers/analyticsReducer";

@connect(
  (state, props) => {
    const document = state.purchases.document;
    return {
      userState: (state.auth && state.auth.user && state.auth.user.addressDetails && state.auth.user.addressDetails.state) || 'AZ',
      tabIndex: props.purchase.externalId === state.purchases.externalId ? state.purchases.tabIndex : 1,
      document: document && props.purchase.externalId === document.externalId ? document : null,
      purchaseState: state.auth.user.addressDetails.state
    };
  },
  dispatch => ({
    purchaseFetchAction: (externalId) => dispatch(purchaseFetchAction(externalId)),
    purchaseCardTabChangeAction: (externalId, tabIndex) => dispatch(purchaseCardTabChangeAction(externalId, tabIndex)),
    trackEvent: (event, properties) => dispatch(trackEvent(event, properties))
  })
)
@CSSModules(styles, {allowMultiple: true})
class PurchaseCard extends React.Component {
  static propTypes = {
    userState: PropTypes.string,
    tabIndex: PropTypes.number.isRequired,
    purchase: PropTypes.object.isRequired,
    document: PropTypes.object,
    purchaseState: PropTypes.string.isRequired,
    purchaseFetchAction: PropTypes.func.isRequired,
    purchaseCardTabChangeAction: PropTypes.func.isRequired,
    trackEvent: PropTypes.func,
  };

  constructor(props) {
    super(props);
  }

  @autobind
  handleTabChange(tabIndex) {
    this.setState({lastTabIndex: this.props.tabIndex});
    this.props.purchaseCardTabChangeAction(this.props.purchase.externalId, tabIndex);
  }

  @autobind
  togglePayNow() {
    this.handleTabChange(0);
  }

  @autobind
  toggleDetails() {
    this.handleTabChange(1);
  }

  @autobind
  togglePaymentsSchedule() {
    this.handleTabChange(2);
  }

  @autobind
  purchaseUpdate() {
    this.props.purchaseFetchAction(this.props.purchase.externalId);
  }

  render() {

    const {purchase, userState} = this.props;

    const isActive = isPurchaseActive(purchase);
    const className = classNames('purchaseCard', {isNotActive: !isActive});
    const tabsTheme = isActive ?
      styles :
      {
        ...styles,
        // navigation: styles.tabsInActiveNavigation
      };

    return (
      <div styleName={className} data-at="purchaseCard">
        <Tabs theme={tabsTheme} inverse={true} index={this.props.tabIndex} onChange={this.handleTabChange}>
          <Tab styleName={classNames('tabButtonHidden')} label="">
            <div styleName="tabContent">
              <PayNowForm
                variantClassName="payNowInTab"
                form={`payNowForm_${purchase.externalId}`}
                purchase={purchase}
                closeButtonClick={this.togglePaymentsSchedule}
                doneCallback={this.purchaseUpdate}
                returnCallback={this.togglePaymentsSchedule}
                returnCallbackAlternative={this.toggleDetails}
              />
            </div>
          </Tab>
          <Tab styleName="tabButton" label="Purchase Summary" data-at="purchaseSummary">
            <div styleName={classNames('tabContent', 'isClosed')}>
              <PurchaseDetails purchase={purchase} togglePayNow={this.togglePayNow} togglePaymentsSchedule={this.togglePaymentsSchedule}/>
            </div>
          </Tab>
          <Tab styleName={classNames('tabButton', 'paymentSchedule')} label="Payment Schedule" data-at="paymentSchedule">
            <div styleName="tabContent">
              <PurchaseSchedule purchase={purchase} togglePayNow={this.togglePayNow} />
            </div>
          </Tab>
          <Tab styleName={classNames('tabButton', 'updateDebitCard')} label="Update Debit Card" data-at="updateDebitCard">
            <div styleName="tabContent">
              <UpdateDebitCard purchase={purchase} form={`updateDebitCardForm_${purchase.externalId}`} doneCallback={this.purchaseUpdate} toggleDetails={this.toggleDetails} togglePayNow={this.togglePayNow}/>
            </div>
          </Tab>
        </Tabs>
        <PurchaseInbox userState={userState} purchase={purchase} />
      </div>
    );
  }
}

export default PurchaseCard;



// WEBPACK FOOTER //
// ./src/purchases/PurchaseCard.js